var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('h3',[_vm._v("Payment Methods")]),_vm._l((_vm.fundingOptions),function(option,i){return _c('div',{key:i},[_c('FundingOptionForm',{attrs:{"title":option.title,"selected":_vm.selected,"value":option.value,"description":option.description,"name":'funding-method'},on:{"selectOption":_vm.selectOption}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }